// extracted by mini-css-extract-plugin
export var actionIcon = "_t2-0";